<template>
	<div class="container">
		<Navigation />
		<h2>Contacteer ons telefonisch of via email</h2>
		<div class="card">
			<div class="member">
				<div class="image" v-bind:style="{backgroundImage: 'url(' + imageKantoor +')'}" ></div>
				<div class="title">
					<h3>Conscius</h3>
					<p>Kantoor te Sint-Niklaas</p>
				</div>
				<div class="contact">
					<i class="fas fa-envelope"></i>
					<p>info@conscius-audit.eu</p>
					<i class="fas fa-phone"></i>
					<p>+21(0)3 777 75 79</p>
					<i class="fas fa-map-marker-alt"></i>
					<p>Gentsebaan 71A, bus 101, 9100 Sint-Niklaas</p>
				</div>
			</div>
			<div class="sidenote">
				<p>Best bereikbaar van maandag tot vrijdag tijdens de kantooruren.</p>
			</div>
		</div>
		<div class="map" @click="openMaps">
		</div>
		<Footer />
	</div>
</template>

<script>
	import Navigation from '../components/Navigation'
	import Footer from '../components/Footer'

	export default {
		name: 'Contact',
		components: {
			Navigation,
			Footer,
		},
		data: function() {
			return {
				imageKantoor: require('../assets/consciusIcon_BRAK.jpg')
			}
		},
		methods: {
			openMaps: function() {
				window.open("https://www.google.be/maps/place/Conscius+Bedrijfsrevisoren/@51.1503071,4.1257664,16z/data=!4m5!3m4!1s0x47c38ef586aa2299:0x6cb974ba4e8f1dec!8m2!3d51.149087!4d4.1249191", "_blank");
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '../sass/contact';
</style>
